import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../store';

@customElement('assistant-wrapper')
export class AssistentWrapper extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Boolean})
	smallTitle = false;

	@property({type: Boolean})
	loginRequired = false;

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}
			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}
			.small {
				font: var(--font-widget-small-title);
				margin-bottom: 10px;
			}
			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				flex-direction: column;
				gap: 24px;
			}
			.info {
				font: var(--font-widget-small-title);
				color: var(--color-widget-text);
			}
			.infoLink {
				color: var(--color-widget-text);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
		this.loggedIn = state.userProfile.data.loggedIn;
	}

	render() {
		const s = store.getState();
		return html`
			<div>
				<div class="title ${classMap({small: this.smallTitle})}">
					${this.title[this.lang]}
				</div>
				<div class="box">
					${when(this.loginRequired && !this.loggedIn,
						() => html`<p class="info">
							${msg('The solar radiation is calculated without shading and with orientation to the north.')}<br><br>
							${msg('To access extended configuration options, please')}
						<a class="infoLink" target="_blank"
						   href="https://www.selux.com/int/${this.lang}/landing/aeto-configurator-pro-request">${msg('request login')}.</a></p>
					`,
						() => html`<slot></slot>`)}

				</div>
			</div>

		`;
	}
}
